import React from 'react'

const HeadingTwo = ({heading2}) => {
  return (
   <h2 className='heading2'>{heading2}</h2>
  )
}

export default HeadingTwo